
let colorContrast = {
    '#6869FB': '#f2f2ff',
    '#5582F3': '#f2f6ff',
    '#FC8555': '#fff6f2',
    '#29C392': '#f2fffb',
    '#E94E4F': '#fff2f2'
}

/**
 * 输入某一天日期，获取该日所在周的所有日期
 * @param input_day 代表指定的日期，格式：2018-09-27
 * @returns {any[]} 返回当周所有日期
 */
function getWeek(input_day) {
    // 一天里一共的毫秒数
    let oneDayTime = 1000 * 60 * 60 * 24
    let today = new Date(input_day)
    // 若那一天是周末时，则强制赋值为7
    let todayDay = today.getDay() || 7
    let startDate = new Date(
        today.getTime() - oneDayTime * (todayDay - 1)
    )
    let dateList = new Array()
    for(let i = 0; i < 7; i++){
        let temp = new Date(startDate.getTime() + i * oneDayTime)
        let year = temp.getFullYear()
        let month = temp.getMonth() + 1
        let day = temp.getDate()
        month = month > 9 ? month : ("0" + month)
        day = day > 9 ? day : ("0" + day)
        dateList[i] = `${year}${month}/${day}`
    }
    return dateList
}

/**
 * 获取指定日期的前x天或后x天
 * @param date 代表指定的日期，格式：2018-09-27
 * @param day 传-1表始前一天，传1表始后一天
 * @returns {string} 返回处理后的天，格式：2018-09-27
 */
function getNextDate(date, day) {
    let dd = new Date(date);
    dd.setDate(dd.getDate() + day);
    let y = dd.getFullYear();
    let m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "/" + m + "/" + d;
};


/**
 * 采用正则格式化日期
 * @param fmt 正则格式 例如 yyyy-MM-dd hh:mm:ss
 * @param value 日期字符串或时间戳
 * @returns {*}
 */
function dateFormat(fmt, value) {
    let date;
    if(value == null || value== undefined || value == ""){
       date = new Date();
    }else{
        switch (typeof (value)) {
            //时间戳
            case 'number':
                date = new Date(value);
                break;
            case 'string':
                //兼容IE  2019-06-22T09:55:02.000+0800 >> 2019/06/22 09:55:02
                if (value.indexOf('T') != -1 && value.indexOf('+') != -1) value = value.replace(/-/g, '/').replace('T', ' ').substring(0, value.indexOf('.'))
                date = new Date(value.replace(/-/g, '/').replace('T', ' '));
                break;
            default:
                break;
        }
    }

    let ret;
    let opt = {
        "y+": date.getFullYear().toString(),        // 年
        "M+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "h+": date.getHours().toString(),           // 时
        "m+": date.getMinutes().toString(),         // 分
        "s+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        let reg = new RegExp("(" + k + ")");
        ret = reg.exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

function getMonthWeek(value) {
    let date = new Date();
    if(!(value == null || value== undefined || value == "")) {
        switch (typeof (value)) {
            //时间戳
            case 'number':
                date = new Date(value);
                break;
            case 'string':
                //兼容IE  2019-06-22T09:55:02.000+0800 >> 2019/06/22 09:55:02
                if (value.indexOf('T') != -1 && value.indexOf('+') != -1) value = value.replace(/-/g, '/').replace('T', ' ').substring(0, value.indexOf('.'))
                date = new Date(value.replace(/-/g, '/').replace('T', ' '));
                break;
            default:
                break;
        }
    }
    let w = date.getDay(), d = date.getDate();
    return Math.ceil(
        (d + 6 - w) / 7
    );
};

function _removeArr(srcArr,moveArr){
    return srcArr.filter((x) => !moveArr.some((item) => x === item));
}

export const utils = {
    getWeek:getWeek,
    getNextDate:getNextDate,
    dateFormat:dateFormat,
    _removeArr:_removeArr,
    getMonthWeek:getMonthWeek,
    colorContrast:colorContrast
}
